<template>
  <div>
    <the-header v-if="showHeader" />
    <the-sidebar />
    <v-content>
      <v-container fluid :class="{ 'container-without-padding': !showHeader }">
        <div class="container-flud">
          <router-view></router-view>
        </div>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { check401, setAuthHeaders } from "@/router/interceptors";
import addOnlineTokenToRequestMixin from "@/mixins/addOnlineTokenToRequest";

import TheHeader from "./TheHeader";
import TheSidebar from "./TheSidebar";

export default {
  mixins: [addOnlineTokenToRequestMixin],
  components: {
    TheHeader,
    TheSidebar
  },
  computed: {
    ...mapGetters({
      showHeader: "getShowHeader",
      userAttrs: "getUserAttributes"
    })
  },
  methods: {
    ...mapActions(["fetchEmployeeCommonInfo"]),
    setUserLocale(locale) {
      window.localStorage.setItem("locale", locale);
    }
  },
  watch: {
    userAttrs: {
      immediate: true,
      handler(data) {
        if (!data) return;
        this.setUserLocale(data.locale);
        this.$i18n.set(data.locale);
      }
    },
    "$route.query": {
      immediate: true,
      handler() {
        const isAuth = this.$auth.isAuthenticated();
        if (!isAuth) {
          this.$auth.destroyToken();
          window.location.reload();
        }
      }
    }
  },
  created() {
    this.addOnlineTokenToRequest();
    setAuthHeaders.call(this);
    check401.call(this);
    this.fetchEmployeeCommonInfo(this);
  }
};
</script>

<style lang="scss">
.container-flud {
  // height: 100vh;
}

.v-content {
  padding-top: 0 !important;
}
.v-content__wrap {
  background-color: $bodyColor;
}
</style>